<template>
<div class="chapter">
<div class="inner_page">
<div class="Basic-Text-Frame">
<p class="CN ParaOverride-15" id="_idParaDest-9" xml:lang="en-GB"><span class="CharOverride-14"><a id="_idTextAnchor001"></a>PART ONE</span></p>
<p class="PT" xml:lang="en-GB">The Infiltration</p>
<p class="PT-Date">1967–January 30, 1968</p>
<p class="Map ParaOverride-6"><img alt="" class="_idGenObjectAttribute-5" src="image/Hue_p2.jpg"/></p>
<blockquote class="Caption ParaOverride-3">The moat just outside the northeast wall of the Citadel.</blockquote>
<p class="Map ParaOverride-16"><img alt="" class="_idGenObjectAttribute-6" src="image/P3.1_Che_Thi_Mung.png"/></p>
<blockquote class="Caption">Che Thi Mung<a id="_idTextAnchor002"></a> (left) and Hoang Thi No, <br/>village teenagers with the Huong River Squad <br/>who fought American and ARVN forces.</blockquote>
<p class="Photo"><img alt="" class="_idGenObjectAttribute-7" src="image/P3.2_Frank_Doezema.jpg"/></p>
<blockquote class="Caption">Frank Doezema, <a id="_idTextAnchor003"></a>the army radioman <br/>who manned the guard tower at the MACV compound <br/>when Front troops attacked.</blockquote>
<p class="Photo"><img alt="" class="_idGenObjectAttribute-8" src="image/P3_3New.jpg"/></p>
<blockquote class="Caption">President Johnson <a id="_idTextAnchor004"></a>and General William Westmoreland<a id="_idTextAnchor005"></a> <br/>in the Rose Garden during the general’s November 1967 spizzerinctum tour.</blockquote>
<p class="Photo"><img alt="" class="_idGenObjectAttribute-9" src="image/P3.4_Nguyen_Dac_Xuan.png"/></p>
<blockquote class="Caption">Nguyen Dac Xuan, <a id="_idTextAnchor006"></a>the Buddhist poet who became <br/>a propagandist and commissar for the Front.</blockquote>
<p class="Map"> <img alt="" class="_idGenObjectAttribute-10" src="image/Map2HueAreacopy.png"/><a id="_idTextAnchor007"></a></p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// eBook_V45578.vue?f498ea92